'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "children", "iconLeading", "label", "id", "aria-controls", "aria-disabled", "onClick", "onKeyDown", "className"];
import React, { useContext } from 'react';
import cx from 'classnames';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TabsContext } from "../Tabs/index.mjs";
import { ENTER, SPACE } from "../Tabs/utils.mjs";
import { StyledTabItem } from "./TabItem.mjs";
import { textClass } from "../../styles/layout-theme.mjs";
export function generateEncoreTabId(value) {
  return "".concat(value, "-tab");
}
export var TabItem = /*#__PURE__*/React.forwardRef(function TabItem(_ref, ref) {
  var value = _ref.value,
    children = _ref.children,
    iconLeading = _ref.iconLeading,
    label = _ref.label,
    id = _ref.id,
    ariaControls = _ref['aria-controls'],
    ariaDisabled = _ref['aria-disabled'],
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var Icon = iconLeading;
  var _useContext = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var _useContext2 = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext2.isUsingKeyboard;
  var _useContext3 = useContext(TabsContext),
    selectedTabItem = _useContext3.selectedTabItem,
    handleClick = _useContext3.handleClick,
    tabItems = _useContext3.tabItems;
  var encoreTabId = generateEncoreTabId(value);
  var isSelected = selectedTabItem === encoreTabId;
  var handleAddingTabItemRef = function handleAddingTabItemRef(node) {
    if (node && tabItems) {
      tabItems.set(encoreTabId, node);
    } else if (tabItems) {
      tabItems["delete"](encoreTabId);
    }
    // Make sure that we are handling the ref passed from the customer
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else {
        ref.current = node;
      }
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    // We handle selecting the TabItem in Tabs (this prevents having double events)
    // However, we want to make sure that we are allowing the {Tab} key
    if (e.key === SPACE || e.key === ENTER) {
      e.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  return /*#__PURE__*/React.createElement(StyledTabItem, Object.assign({
    ref: handleAddingTabItemRef,
    className: cx(textClass('bodySmallBold'), className),
    "data-encore-id": ENCORE_DATA_IDS.TabItem,
    tabIndex: isSelected ? undefined : -1,
    role: "tab",
    type: "button",
    id: id !== null && id !== void 0 ? id : encoreTabId,
    "aria-controls": ariaControls !== null && ariaControls !== void 0 ? ariaControls : "".concat(value, "-panel"),
    "aria-disabled": ariaDisabled,
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isUsingKeyboard: isUsingKeyboard,
    "aria-selected": isSelected,
    onClick: ariaDisabled ? undefined : function (e) {
      return handleClick(e, encoreTabId, onClick);
    },
    onKeyDown: handleKeyDown,
    "data-encore-tab-id": encoreTabId
  }, props), children ? children : /*#__PURE__*/React.createElement(React.Fragment, null, Icon && /*#__PURE__*/React.createElement(Icon, {
    size: "small"
  }), label));
});